/* eslint-disable */



const text = {
  // 'getCurrLangSpesh' is an escape hatch to get current chosen language
  'getCurrLang!': [
    'en',
    'de',
    'zh-hans',
    'zh-hant',
    'fr',
    'es',
    'pl',
  ],
  // if key not found defaults to this
  txtErr: [
    'Error! Text not found',
    'Error! Text nicht gefunden',
    '错误！ 找不到文字',
    '錯誤！ 找不到文字',
    'Erreur ! Texte introuvable',
    '¡Error! No se encuentra el texto',
    'Błąd! Nie znaleziono tekstu',
  ],
  introduction: [
    'Welcome to Cambridge Audio Learn. Here you will find information relating to our extensive range of award-winning products. “Courses” provide an in-depth learning experience based around a single product or range and “Resources” provides links to our Top Tips product guides, press reviews and support pages. Click on the links below to get started.',
    'Error! Text nicht gefunden',
    '错误！ 找不到文字',
    '錯誤！ 找不到文字',
    'Erreur ! Texte introuvable',
    '¡Error! No se encuentra el texto',
    'Błąd! Nie znaleziono tekstu',
  ],
  attachments: [
    'Attachments',
    'Error! Text nicht gefunden',
    '错误！ 找不到文字',
    '錯誤！ 找不到文字',
    'Erreur ! Texte introuvable',
    '¡Error! No se encuentra el texto',
    'Błąd! Nie znaleziono tekstu',
  ],
  noResult: [
    'No matches found.',
    'Error! Text nicht gefunden',
    '错误！ 找不到文字',
    '錯誤！ 找不到文字',
    'Erreur ! Texte introuvable',
    '¡Error! No se encuentra el texto',
    'Błąd! Nie znaleziono tekstu',
  ],
  title: [
    'Learning',
    'Lernen',
    '学习',
    '學習',
    'Apprentissage',
    'Formación',
    'Nauka',
  ],
  courses: [
    'Courses',
    'Lernen',
    '学习',
    '學習',
    'Apprentissage',
    'Formación',
    'Nauka',
  ],
  date: [
    'Date',
    'Lernen',
    '学习',
    '學習',
    'Apprentissage',
    'Formación',
    'Nauka',
  ],
  chooseCourse: [
    'Available Courses',
    'Verfügbare Kurse',
    '可用课程',
    '可用課程',
    'Sessions de formation disponibles',
    'Cursos disponibles',
    'Dostępne kursy',
  ],
  course: [
    'Course',
    'Kurs',
    '课程',
    '課程',
    'Sessions de formation',
    'Curso',
    'Kurs',
  ],
  about: [
    'About',
    'Über',
    '关于',
    '關於)',
    'À propos',
    'Acerca de',
    'O',
  ],
  signIn: [
    'Sign in',
    'Anmelden',
    '登入',
    '登入',
    'S\'identifier',
    'Iniciar sesión',
    'Zaloguj się',
  ],
  signOut: [
    'Sign out',
    'Ausloggen',
    '登出',
    '登出',
    'Se déconnecter',
    'Cerrar sesión',
    'Wyloguj się',
  ],
  register: [
    'Register',
    'Registrieren',
    '注册',
    '註冊',
    'S\'inscrire',
    'Crear cuenta',
    'Rejestracja',
  ],
  email: [
    'Email',
    'E-mail',
    '电子邮件',
    '電子郵件',
    'E-mail',
    'Correo electrónico',
    'E-mail',
  ],
  password: [
    'Password',
    'Passwort',
    '密码',
    '密碼',
    'Mot de passe',
    'Contraseña',
    'Hasło',
  ],
  confirmPassword: [
    'Confirm password',
    'Bestätige das Passwort',
    '确认密码',
    '確認密碼',
    'Confirmer le mot de passe',
    'Confirmar contraseña',
    'Potwierdź hasło',
  ],
  loggingIn: [
    'Logging in...',
    'Einloggen...',
    '登录中...',
    '登錄中...',
    'Connexion en cours',
    'Accediendo...',
    'Logowanie...',
  ],
  complete: [
    'Complete',
    'Komplett',
    '完成',
    '完成',
    'Terminé',
    'Terminar',
    'Zakończ',
  ],
  checkAnswers: [
    'Check answers',
    'Antworten kontrollieren',
    '检查答案',
    '檢查答案',
    'Vérifier les réponses',
    'Comprobar respuestas',
    'Sprawdź odpowiedzi',
  ],
  resources: [
    'Resources',
    'Ressourcen',
    '资源',
    '資源',
    'Ressources',
    'Recursos',
    'Materiały',
  ],
  previous: [
    'Previous',
    'Bisherige',
    '上一个',
    '上一個',
    'Précédent',
    'Anterior',
    'Poprzedni',
  ],
  next: [
    'Next',
    'Nächster',
    '下一个',
    '下一個',
    'Suivant',
    'Siguiente',
    'Następny',
  ],
  selectAnswer: [
    'Select an answer',
    'Wählen Sie eine Antwort aus',
    '选择一个答案',
    '選擇一個答案',
    'Choisir une réponse',
    'Seleccione una respuesta',
    'Wybierz odpowiedź',
  ],
  changeLanguage: [
    'Change language',
    'Sprache ändern',
    '改变语言',
    '改變語言',
    'Changer la langue',
    'Cambiar idioma',
    'Zmień język',
  ],
  chooseLanguage: [
    'Please choose a language',
    'Bitte wählen Sie eine Sprache',
    '请选择一种语言',
    '請選擇一種語言',
    'Veuillez choisir une langue',
    'Escoja una respuesta',
    'Proszę wybrać język',
  ],
  english: [
    'English',
    'Englisch',
    '英语',
    '英語',
    'Anglais',
    'Inglés',
    'Angielski',
  ],
  german: [
    'German',
    'Deutsche',
    '德语',
    '德語',
    'Allemand',
    'Alemán',
    'Niemiecki',
  ],
  chineseHans: [
    'Simplified Chinese',
    'Vereinfachtes Chinesisch',
    '简体中文',
    '簡體中文',
    'Chinois simplifié',
    'Chino simplificado',
    'Chiński Uproszczony',
  ],
  chineseHant: [
    'Traditional Chinese',
    'Traditionelles Chinesisch',
    '繁體中文',
    '簡體中文',
    'Chinois traditionnel',
    'Chino tradicional',
    'Chiński Tradycyjny',
  ],
  french: [
    'French',
    'Französisch',
    '法语',
    '法語',
    'Français',
    'Francés',
    'Francuski',
  ],
  spanish: [
    'Spanish',
    'Spanisch',
    '西班牙语',
    '西班牙語',
    'Espagnol',
    'Español',
    'Hiszpański',
  ],
  polish: [
    'Polish',
    'Polnish',
    '波兰语',
    '波蘭語',
    'Polonais',
    'Polaco',
    'Polski',
  ],
  confirm: [
    'Confirm',
    'Bestätigen',
    '确认',
    '確認',
    'Confirmer',
    'Confirmar',
    'Zatwierdź',
  ],
  languageHelp: [
    'Press confirm to save your changes and return to the main page',
    'Drücken Sie bestätigen, um Ihre Änderungen zu speichern und zur Hauptseite zurückzukehren',
    '按确认保存更改并返回主页面',
    '按確認保存更改並返回主頁面',
    'Veuillez confirmer pour enregistrer vos modifications et revenir à la page d\'accueil',
    'Confirme para guardar sus cambios y volver a la página principal',
    'Naciśnij \'zatwierdź\' by zapisać wprowadzone zmiany i powrócić do strony głównej',
  ],
  assessment: [
    'Assessment',
    'Bewertung',
    '评定',
    '評定',
    'Évaluation',
    'Evaluación',
    'Ocena',
  ],
  passMinimum: [
    'Pass minimum',
    'Mindestanforderung',
    '通过最低限度',
    '通過最低限度',
    'Note minimum pour réussir le test',
    'Aprobado mínimo',
    'Minimum potrzebne do zaliczenia kursu',
  ],
  passed: [
    'Passed',
    'Bestanden',
    '通过',
    '通過',
    'Test réussi',
    'Aprobado',
    'Zaliczony',
  ],
  failed: [
    'Failed',
    'Gescheitert',
    '失败',
    '失敗',
    'Test échoué',
    'Suspenso',
    'Niezaliczony',
  ],
  answerAll: [
    'You must answer every question',
    'Bitte beantworten Sie jede Frage',
    '你必须回答每个问题',
    '你必須回答每個問題',
    'Vous devez répondre à chaque question',
    'Debe contestar a todas las preguntas',
    'Musisz odpowiedzieć na każde pytanie',
  ],
  missing: [
    'Missing',
    'Fehlt',
    '遗漏',
    '遺漏',
    'Manquant',
    'Ausente',
    'Brakujące',
  ],
  tryAgain: [
    'Try again',
    'Versuchen Sie es noch einmal',
    '再试一次',
    '再试一次',
    'Veuillez essayer de nouveau',
    'Inténtelo de nuevo',
    'Spróbuj jeszcze raz',
  ],
  congratulationsCompletingCourse: [
    'Congratulations on completing the course!',
    'Herzlichen Glückwunsch zum Abschluss des Kurses!',
    '恭喜您完成课程！',
    '恭喜您完成課程！',
    'Félicitations : vous avez terminé la formation !',
    '¡Enhorabuena por terminar el curso!',
    'Gratulujemy ukończenia kursu!',
  ],
  weSent: [
    'We have automatically emailed your certificate. If you have not received it within 24 hours please click the link below.',
    'Herzlichen Glückwunsch zum Abschluss des Kurses!',
    '恭喜您完成课程！',
    '恭喜您完成課程！',
    'Félicitations : vous avez terminé la formation !',
    '¡Enhorabuena por terminar el curso!',
    'Gratulujemy ukończenia kursu!',
  ],
  certificate: [
    'Certificate',
    'Zertifikat',
    '证书',
    '證書',
    'Certificat',
    'Certificado',
    'Certyfikat',
  ],
  emailTo: [
    'RESEND CERTIFICATE',
    'E-Mail-Zertifikat',
    '电子邮件证书到',
    '電子郵件證書到',
    'Envoyer le certificat par e-mail à',
    'Enviar el certificado por correo electrónico a',
    'Wyślij certyfikat na maila',
  ],
  title404: [
    '404: Page not found',
    '404 Seite nicht gefunden',
    '404页面不存在',
    '404頁面不存在',
    '404 – Page introuvable',
    '404: La página no se encuentra',
    '404: nie znaleziono strony',
  ],
  followToHome: [
    'Follow the link to return to the home page',
    'Folgen Sie dem Link, um zur Startseite zurückzukehren',
    '点击链接返回主页',
    '點擊鏈接返回主頁',
    'Cliquer sur le lien pour revenir à la page d\'accueil',
    'Siga el enlace para volver a la página de inicio',
    'Kliknij w link by powrócić do strony głównej',
  ],
  homePage: [
    'Home page',
    'Startseite',
    '主页',
    '主頁',
    'Page d\'accueil',
    'Página de inicio',
    'Strona główna',
  ],
  firstName: [
    'First Name',
    'Vorname',
    '名字',
    '名字',
    'Prénom',
    'Nombre',
    'Imię',
  ],
  lastName: [
    'Last Name',
    'Nachname',
    '姓',
    '姓',
    'Nom',
    'Apellidos',
    'Nazwisko',
  ],
  company: [
    'Company',
    'Unternehmen',
    '公司',
    '公司',
    'Société',
    'Empresa',
    'Nazwa firmy',
  ],
  companyStore: [
    'Company/Store',
    'Unternehmen',
    '公司',
    '公司',
    'Société',
    'Empresa',
    'Nazwa firmy',
  ],
  store: [
    'Store',
    'Unternehmen',
    '公司',
    '公司',
    'Société',
    'Empresa',
    'Nazwa firmy',
  ],
  country: [
    'Country',
    'Land',
    '国家',
    '國家',
    'Pays',
    'País',
    'Kraj',
  ],
  resetSuccess: [
    'We have sent you an email with further instructions.',
    'Erfolg! Wir haben Ihnen eine E-Mail mit weiteren Anweisungen gesendet.',
    '成功！ 我们已向您发送了一封电子邮件',
    '成功！ 我們已向您發送了一封電子郵件',
    'Nous vous avons envoyé un e-mail contenant des instructions supplémentaires.',
    'Le hemos enviado un correo electrónico con más instrucciones.',
    'Wysłaliśmy Ci email z instrukcjami dalszego postępowania',
  ],
  resetPassword: [
    'Reset password',
    'Passwort zurücksetzen',
    '重设密码',
    '重設密碼',
    'Réinitialiser le mot de passe',
    'Restablecer contraseña',
    'Resetuj hasło',
  ],
  takeCourse: [
    'Take course',
    'Einen Kurs nehmen',
    '参加课程',
    '參加課程',
    'Commencer la session',
    'Hacer el curso',
    'Rozpocznij kurs',
  ],
  courseComplete: [
    'Course complete',
    'Kurs abgeschlossen',
    '课程完成',
    '課程完成',
    'Session terminée',
    'Curso terminado',
    'Kurs ukończony',
  ],
  confirmTsAndCs: [
    'Tick to confirm you have read and agree with the Privacy & Cookie Policy and Terms of Use.',
    'Kreuzen Sie an, um zu bestätigen, dass Sie die AGB\'s gelesen und akzeptiert haben',
    '勾选确认您已阅读并同意Ts＆C',
    '勾選確認您已閱讀並同意Ts＆C',
    'Cochez la case pour confirmer que vous avez lu et compris les Conditions générales',
    'Marque para confirmar que ha leído y está de acuerdo con los términos y condiciones',
    'Zaznacz by potwierdzić, że przeczytałeś i zgadzasz się z regulaminem',
  ],
  cancel: [
    'Cancel',
    'Stornieren',
    '取消',
    '取消',
    'Annuler',
    'Cancelar',
    'Anuluj',
  ],
  // resetPass: [
  //   'Reset password',
  //   'Passwort zurücksetzen',
  //   'reset password (chHans)',
  //   'reset password (chHant)',
  //   'reset password (fr)',
  //   'reset password (es)',
  //   'reset password (pl)',
  // ],
  registering: [
    'Registering you...',
    'Registrieren Sie sich...',
    '重设密码',
    '重設密碼',
    'Inscription en cours...',
    'Inscribiéndole...',
    'Trwa rejestracja...',
  ],
  emailChanged: [
    'Email changed',
    'E-Mail geändert',
    '电邮已更改',
    '電郵已更改',
    'E-mail modifié',
    'Correo electrónico cambiado',
    'Adres e-mail zmieniony',
  ],
  profile: [
    'Profile',
    'Profil',
    '个人档案',
    '個人檔案',
    'Profil',
    'Perfil',
    'Profil',
  ],
  edit: [
    'Edit',
    'Bearbeiten',
    '编辑',
    '編輯',
    'Modifier',
    'Editar',
    'Edytuj',
  ],
  home: [
    'Home',
    'Home',
    '主页',
    '主頁',
    'Accueil',
    'Inicio',
    'Strona główna',
  ],
  yourProfile: [
    'Your Profile',
    'Ihr Profil',
    '你的个人档案',
    '你的個人檔案',
    'Votre profil',
    'Su perfil',
    'Twój profil',
  ],
  language: [
      'Language',
      'Sprache',
      '语言',
      '語言',
      'Langue',
      'Idioma',
      'Język',
  ],
    select: [
      'Select',
      'Wählen',
      '选择',
      '選擇',
      'Sélectionner',
      'Seleccionar',
      'Wybierz',
    ],
    welcome: [
      'Welcome to Cambridge Audio E-Learning',
      'Willkommen bei Cambridge Audio E-Learning',
      '欢迎来到剑桥音响电子学习课程',
      '歡迎來到劍橋音響電子學習課程',
      'Bienvenue dans l\'apprentissage en ligne Cambridge Audio',
      'Bienvenido/a a la formación a distancia de Cambridge Audio',
      'Witamy na stronie Cambridge Audio E-Learning',
    ],
    clickOnTheLink: [
      'Click on the link below to access individual product range modules. You will also find useful product resources at the end of each module.',
      'Klicken Sie auf den unten stehenden Link, um auf einzelne Produktbereichsmodule zuzugreifen. Am Ende jedes Moduls finden Sie auch nützliche Produktressourcen.',
      '点击下面的链接可访问各款产品系列模组。您还可以在每个模组的尾部找到有用的产品资源。',
      '點擊下面的鏈接可訪問各款產品系列模組。 您還可以在每個模組的尾部找到有用的產品資源。',
      'Cliquez sur le lien ci-dessous pour accéder aux modules individuels. Vous trouverez également des ressources utiles sur les produits à la fin de chaque module.',
      'Haga clic en el enlace a continuación para acceder a los módulos individuales. Además, podrá encontrar recursos de productos útiles al final de cada módulo.',
      'Kliknij na poniższy link by uzyskać dostęp do modułów dotyczących poszczególnych linii produktowych. Na końcu każdego modułu znajdziesz użyteczne materiały dotyczące produktów.',
    ],
    return: [
      'Return',
      'Zurück',
      '返回',
      '返回',
      'Retour',
      'Volver',
      'Wróć',
    ],
    backToCourse: [
      'Back To Course',
      'Zurück zum Kurs',
      '回到课程',
      '回到課程',
      'Retour à la session',
      'Volver al curso',
      'Wróć do kursu',
    ],
    forgotPassword: [
      'Forgot your password?',
      'Haben Sie Ihr Passwort vergessen?',
      '忘记密码了吗？',
      '忘記密碼了嗎？',
      'Vous avez oublié votre mot de passe ?',
      '¿Ha olvidado su contraseña?',
      'Zapomniałeś hasło?',
    ],
    requestPassword: [
      'Request new password',
      'Fordern Sie ein neues Passwort an',
      '需要新密码',
      '需要新密碼',
      'Demander un nouveau mot de passe',
      'Solicitar una contraseña nueva',
      'Poproś o nowe hasło',
    ],
    send: [
      'Send',
      'Senden',
      '发送',
      '發送',
      'Envoyer',
      'Enviar',
      'Wyślij',
    ],
};

const translate = (lang) => {
  switch (lang) {
    case 'pl':
        return (string) => validateTranslation(string, 6)[6];
    case 'es':
        return (string) => validateTranslation(string, 5)[5];
    case 'fr':
        return (string) => validateTranslation(string, 4)[4];
    case 'zh-hant':
        return (string) => validateTranslation(string, 3)[3];
    case 'zh-hans':
        return (string) => validateTranslation(string, 2)[2];
    case 'de':
      return (string) => validateTranslation(string, 1)[1];
    case 'en':
    default:
      return (string) => validateTranslation(string, 0)[0];
  }
};

const validateTranslation = (string, length) => {
  return text[string] && length <= (text[string].length - 1)
    ? text[string]
    : text['txtErr']
};

export default translate;



// WEBPACK FOOTER //
// ./src/config/text.js